export default "__VITE_ASSET__CUuCuBn1__"